export default "__VITE_ASSET__B5d4kYws__"